import { startCase, toLower } from 'lodash';
import {
  AutocompleteInput,
  BooleanField,
  BooleanInput,
  ChipField,
  CreateButton,
  Datagrid,
  DateField,
  FunctionField,
  ImageField,
  List,
  ReferenceField,
  ReferenceInput,
  ReferenceManyField,
  SingleFieldList,
  TextField,
  TopToolbar,
  type ListProps,
} from 'react-admin';

import { getResourceFilter } from '@/constants';

const AlbumEngFilters = [
  <ReferenceInput
    key='engineer'
    label='Engineer'
    source='ResourceIdentifier'
    reference='resources'
    alwaysOn
    sort={{ field: 'Name', order: 'ASC' }}
    filter={{ ...getResourceFilter() }}
  >
    <AutocompleteInput
      optionText='Name'
      label='Engineers'
      filterToQuery={(searchText) => ({ name: searchText })}
      sx={{ minWidth: 250 }}
    />
  </ReferenceInput>,

  <BooleanInput
    key='sw'
    source='SelectedWork'
    label='Selected Work'
    alwaysOn
    sx={{ mx: 1 }}
  />,
  <BooleanInput
    key='ch'
    source='CareerHighlight'
    label='Career Highlight'
    alwaysOn
    sx={{ mx: 1 }}
  />,
  <BooleanInput
    key='atmos'
    source='Atmos'
    label='Atmos'
    alwaysOn
    sx={{ mx: 1 }}
  />,
  <BooleanInput
    key='stereo'
    source='Stereo'
    label='Stereo'
    alwaysOn
    sx={{ mx: 1 }}
  />,
  <BooleanInput
    key='vinyl'
    source='Vinyl'
    label='Vinyl'
    alwaysOn
    sx={{ mx: 1 }}
  />,
  <BooleanInput
    key='hasAwards'
    source='HasAwards'
    label='Awards'
    alwaysOn
    sx={{ mx: 1 }}
  />,
];
function EngineerListActions() {
  return (
    <TopToolbar>
      <CreateButton to='/albums/create' label='Create Album' />
    </TopToolbar>
  );
}
function AlbumEngineerList(props: ListProps) {
  return (
    <List
      {...props}
      filters={AlbumEngFilters}
      sort={{ field: 'DateAdded', order: 'DESC' }}
      perPage={20}
      resource='album/engineers'
      title='Engineers'
      actions={<EngineerListActions />}
    >
      <Datagrid
        rowClick={(_id, _resource, record) => `/albums/${record.DiscographyAlbumIdentifier}`}
      >
        <ReferenceField
          label='Album Cover'
          source='DiscographyAlbumIdentifier'
          reference='albums'
          link='show'
        >
          <ImageField
            source='CoverImageUrl'
            sx={{
              '& .RaImageField-image': {
                width: 96,
                height: 96,
                objectFit: 'cover',
                borderRadius: 2,
                display: 'block',
              },
            }}
          />
        </ReferenceField>

        <ReferenceField
          label='Album'
          source='DiscographyAlbumIdentifier'
          reference='albums'
          link='show'
        >
          <TextField source='Title' />
        </ReferenceField>

        <ReferenceField
          label='Artist'
          source='DiscographyAlbumIdentifier'
          reference='albums'
        >
          <ReferenceManyField
            reference='album/artists'
            target='DiscographyAlbumIdentifier'
          >
            <SingleFieldList linkType={false}>
              <ReferenceField
                source='DiscographyArtistIdentifier'
                reference='artists'
                link={false}
              >
                <ChipField source='Name' />
              </ReferenceField>
            </SingleFieldList>
          </ReferenceManyField>
        </ReferenceField>

        <DateField source='SubmittedDate' label='Submitted' />
        <BooleanField source='SelectedWork' label='Selected Work' />
        <BooleanField source='CareerHighlight' label='Career Highlight' />
        <BooleanField source='Atmos' label='Atmos' />
        <BooleanField source='Stereo' label='Stereo' />
        <BooleanField source='Vinyl' label='Vinyl' />
        <TextField source='AtmosTracks' label='Atmos Tracks' />
        <TextField source='StereoTracks' label='Stereo Tracks' />
        <ReferenceManyField
          label='Awards'
          reference='album/engineer/awards'
          target='DiscographyAlbumEngIdentifier'
        >
          <SingleFieldList linkType={false}>
            <FunctionField
              render={(r) => (
                <ChipField
                  record={{
                    Category: startCase(toLower(r.Category ?? '')),
                  }}
                  source='Category'
                />
              )}
            />
          </SingleFieldList>
        </ReferenceManyField>

        <TextField source='AddedBy' label='Added By' />
        <DateField
          source='DateAdded' label='Date Added'
          showTime
        />
        <TextField source='ModifiedBy' label='Modified By' />
        <DateField
          source='DateModified' label='Date Modified'
          showTime
        />
      </Datagrid>
    </List>
  );
}

export default AlbumEngineerList;
